/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Progress
 */
export interface Progress {
  /**
   *
   */
  time: number;
  /**
   *
   */
  percentage: number;
}

/**
 * Check if a given object implements the Progress interface.
 */
export function instanceOfProgress(value: object): value is Progress {
  if (!("time" in value) || value["time"] === undefined) return false;
  if (!("percentage" in value) || value["percentage"] === undefined) return false;
  return true;
}

export function ProgressFromJSON(json: any): Progress {
  return ProgressFromJSONTyped(json, false);
}

export function ProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Progress {
  if (json == null) {
    return json;
  }
  return {
    time: json["time"],
    percentage: json["percentage"],
  };
}

export function ProgressToJSON(json: any): Progress {
  return ProgressToJSONTyped(json, false);
}

export function ProgressToJSONTyped(
  value?: Progress | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    time: value["time"],
    percentage: value["percentage"],
  };
}
